import React from 'react';

import AppHeader from '../../../../Layout/Header';
import FooterComponent from '../../../../Layout/Footer';
import banner from '../../../../Assets/Linkages/StudentSatelliteOutreach/Student-Satellite-Outreach-Banner.jpg';
import '../../../../Styles/Linkages&Outreach.css';
import StudentSatelliteIntroduction from './StudentSatelliteIntroduction';
import StudentSatelliteLegacy from './StudentSatelliteLegacy';
import StudentSatelliteTraining from './StudentSatelliteTraining';
import StudentSatelliteEvents from './StudentSatelliteEvents';

const StudentSatelliteOutreach = () => (
  <>
    <AppHeader />
    <main className="student-satellite-outreach-page">
      <section className="outreach-event-hero" aria-label="Student Satellite Outreach">
        <img
          className="outreach-event-banner"
          src={banner}
          alt="Student Satellite Outreach"
        />
      </section>
      <StudentSatelliteIntroduction />
      <StudentSatelliteLegacy />
      <StudentSatelliteTraining />
      <StudentSatelliteEvents />
    </main>
    <FooterComponent />
  </>
);

export default StudentSatelliteOutreach;
